import { Injectable } from '@angular/core';
import { NbTokenStorage } from '@nebular/auth';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { ExternalMember } from '../../shared/models/member/external-member.model';
import { InternalMember } from '../../shared/models/member/internal-member.model';
import { ExternalMemberRepository } from '../../shared/services/member/external-member-repository.service';
import { InternalMemberRepository } from '../../shared/services/member/internal-member-repository.service';

@Injectable({
  providedIn: 'root',
})
export class CurrentMemberProvider {

  constructor(
    private oauth: OAuthService,
    private nbTokenService: NbTokenStorage,
    private externalMemberRepository: ExternalMemberRepository,
    private internalMemberRepository: InternalMemberRepository,
  ) {
  }

  public get(): Observable<ExternalMember | InternalMember> {
    const isInternal = this.isInternal();
    const uuid = this.getUuid();

    return isInternal ? this.internalMemberRepository.get(uuid) : this.externalMemberRepository.get(uuid);
  }

  public isInternal(): boolean {
    return this.oauth.hasValidAccessToken();
  }

  public isExternal(): boolean {
    return this.nbTokenService.get().isValid();
  }

  public isAuthenticated(): boolean {
    return this.isExternal() || this.isInternal();
  }

  public getUuid(): string {
    if (this.isInternal()) {
      return this.oauth.getIdentityClaims()['uuid'] as string;
    }

    if (this.isExternal()) {
      return this.nbTokenService.get().getPayload()['uuid'];
    }

    return '';
  }
}
